import React from "react";
import { Alert } from "reactstrap";

// Components
import { CheckmarkCircleIcon, CrossIcon } from "../../../../assets/img/icons";

const NoConflictNotificationToggle = props => {
  const { setDealConflictToggleValues } = props;
  return (
    <>
      <div className="alerts-wrapper">
        <Alert
          color="success"
          className={
            "d-flex align-items-center justify-content-stretch text-white"
          }
        >
          <CheckmarkCircleIcon />
          <p className="ml-3 mb-0 font-weight-bold mr-auto text-white">
            There are no deal conflicts in HubSpot.
          </p>
          <div className="close-alert mr-0 ml-0">
            <button
              className="btn-plain btn text-white p-0"
              type="button"
              onClick={() => {
                setDealConflictToggleValues({
                  isHubSpotNoDealConflictNotification: false
                });
              }}
            >
              <CrossIcon />
            </button>
          </div>
        </Alert>
      </div>
    </>
  );
};

export default NoConflictNotificationToggle;
